var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-container tw-col-span-3"},[_c('profile-settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }